export const BACK_URL = "https://parking-management-server.herokuapp.com/";
// export const BACK_URL = "https://localhost:5000/";
// https://parking-management-server.herokuapp.com/
// https://localhost:5000/
